import { Stack } from '@mui/material'
import { CircleFlag } from '@/components/CircleFlag'
import { COUNTRIES } from '@/constants/regions/countries'
import { Country } from '@/types/region'

import { Autocomplete } from '../Autocomplete'
import { RegionChip } from '../common/RegionChip'

export const COUNTRY_AUTOCOMPLETE_LABEL = 'Country'
export const COUNTRY_AUTOCOMPLETE_TEST_IDS = {
  autocomplete: 'country-autocomplete',
  valueChip: (countryCode: string) => `country-autocomplete-${countryCode}`
} as const

type Props = {
  value: Country[]
  onChange: (value: Country[]) => void
  label?: string
  testId?: string
  withFlags?: boolean
}

export const CountryAutocomplete = ({ withFlags, ...props }: Props) => {
  return (
    <Autocomplete
      label={COUNTRY_AUTOCOMPLETE_LABEL}
      testId={COUNTRY_AUTOCOMPLETE_TEST_IDS.autocomplete}
      {...props}
      multiselect
      isOptionEqualToValue={(option, value) => option.iso2 === value.iso2}
      filterOptions={(options, { inputValue }) =>
        options.filter(
          (option) =>
            option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.iso2.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.name.toLowerCase().startsWith(inputValue.toLowerCase())
        )
      }
      getOptionLabel={(option) => option.name}
      renderValue={(selected) => (
        <>
          {selected.map((country) => (
            <RegionChip
              withFlag={withFlags}
              testId={COUNTRY_AUTOCOMPLETE_TEST_IDS.valueChip(country.iso2)}
              region={country}
              ChipSx={{
                my: 0.4,
                mx: 0.2
              }}
              onDelete={() => props.onChange(selected.filter((c) => c.iso2 !== country.iso2))}
            />
          ))}
        </>
      )}
      renderOption={(props, option) => (
        <Stack direction="row" alignItems="center" gap={1} {...props} component="li">
          {withFlags && (
            <CircleFlag
              countryCode={option.iso2.toLowerCase()}
              style={{
                width: '1rem',
                height: '1rem'
              }}
            />
          )}
          {option.name}
        </Stack>
      )}
      options={COUNTRIES.sort((a, b) => a.name.localeCompare(b.name))}
    />
  )
}
